import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { requestNotificationPermission } from './utils/notifications';

// Layout
import Sidebar from './components/Layout/Sidebar';
import Header from './components/Layout/Header';

// Pages
import WorkersPage from './pages/WorkersPage';
import WorkerDetailPage from './pages/WorkerDetailPage';
import DashboardPage from './pages/DashboardPage';
import ScreenshotsPage from './pages/ScreenshotsPage';
import ApplicationsPage from './pages/ApplicationsPage';
import ClipboardPage from './pages/ClipboardPage';
import USBActivityPage from './pages/USBActivityPage';
import IncidentsPage from './pages/IncidentsPage';
import SettingsPage from './pages/SettingsPage';
import TimelinePage from './pages/TimelinePage';
import ReportsPage from './pages/ReportsPage';
import SearchPage from './pages/SearchPage';
import AnalyticsPage from './pages/AnalyticsPage';
import BrowserHistoryPage from './pages/BrowserHistoryPage';
import PrinterActivityPage from './pages/PrinterActivityPage';
import NetworkTrafficPage from './pages/NetworkTrafficPage';
import WorkerLogsPage from './pages/WorkerLogsPage';
import PoliciesPage from './pages/PoliciesPage';
import ControlPage from './pages/ControlPage';
import ConnectionStatus from './components/ConnectionStatus';
import KeyboardShortcutsDialog from './components/KeyboardShortcutsDialog';

const SIDEBAR_WIDTH = 260;

function AppContent() {
  return (
    <Routes>
      <Route path="/" element={<WorkersPage />} />
      <Route path="/workers" element={<WorkersPage />} />
      <Route path="/analytics" element={<AnalyticsPage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/policies" element={<PoliciesPage />} />
      <Route path="/control" element={<ControlPage />} />

      <Route path="/worker/:workerId" element={<WorkerDetailPage />} />
      <Route path="/worker/:workerId/screenshots" element={<ScreenshotsPage />} />
      <Route path="/worker/:workerId/applications" element={<ApplicationsPage />} />
      <Route path="/worker/:workerId/clipboard" element={<ClipboardPage />} />
      <Route path="/worker/:workerId/usb" element={<USBActivityPage />} />
      <Route path="/worker/:workerId/incidents" element={<IncidentsPage />} />
      <Route path="/worker/:workerId/timeline" element={<TimelinePage />} />
      <Route path="/worker/:workerId/reports" element={<ReportsPage />} />
      <Route path="/worker/:workerId/browser" element={<BrowserHistoryPage />} />
      <Route path="/worker/:workerId/printer" element={<PrinterActivityPage />} />
      <Route path="/worker/:workerId/network" element={<NetworkTrafficPage />} />
      <Route path="/worker/:workerId/logs" element={<WorkerLogsPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
    </Routes>
  );
}

function App() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    requestNotificationPermission();
    const savedMode = localStorage.getItem('darkMode') === 'true';
    setDarkMode(savedMode);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (darkMode) root.classList.add('dark');
    else root.classList.remove('dark');
  }, [darkMode]);

  return (
    <Router>
      <div className="flex h-screen w-screen overflow-hidden bg-background text-foreground">
        <Sidebar width={SIDEBAR_WIDTH} />
        <div className="flex min-w-0 flex-1 flex-col">
          <Header darkMode={darkMode} setDarkMode={setDarkMode} />
          <main className="scrollbar-thin flex-1 overflow-auto bg-background p-6">
            <ConnectionStatus />
            <AppContent />
          </main>
        </div>
        <KeyboardShortcutsDialog />
      </div>
    </Router>
  );
}

export default App;
